export function notify({ title, description, status = 'info' }) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('rsworks:notify', {
      detail: { title, description, status },
    }),
  );
}

export function notifyError(description, title = 'Action failed') {
  notify({ title, description, status: 'error' });
}
